<template>

    <div class="add_to_cart_box" v-if="product_id > 0">
        <div :class="['prices', grant ? 'flex-column' : '']" v-if="sale_price">
            <template v-if="grant && ball > 0">
                <div class="d-flex align-baseline gap-xs">
                    <div class="sale_price">{{ sale_price }}</div>
                    <div class="price">{{ sale_grant }}</div>
                </div>
                <div class="mt-xs">
                    <div class="d-inline-flex text-small bg-light-green fw-bold py-xs px-sm radius-md">
                        <i class="icon-gift"></i> {{ sale_grant }} will be covered by grant
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="sale_price">{{ sale_price }}</div>
                <div class="price" v-if="1 === 0 && sale_price !== price ">{{ price }}</div>
            </template>
        </div>

        <div class="sku-groups" v-if="sku_group">
            <div class="sku-group" v-for="(group_title, group_id) in sku_group">
                <div class="sku-group-name">{{ group_title }}</div>
                <div class="sku-items">
                    <template v-for="item in sku_items[group_id]">
                        <div :class="'sku-item ' + checkActive(item, group_id) ">
                            <div v-if="item.image" class="sku-item-image">
                                <img
                                    :src="item.thumbnail"
                                    :title="capitalizeFirstLetter( item.property_name )"
                                    loading="lazy"
                                />
                            </div>
                            <div class="sku-item-title" v-else>{{ capitalizeFirstLetter( item.property_name ) }}</div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <button
            :class="[
                'btn',
                'btn--primary',
                'btn--full',
                'btn--large',
                'btn--large-none',
                'btn--loader',
                in_cart ? 'btn--green' : ''
            ]"
            :disabled="isLoading"
            @click="addToCart"
        >{{ in_cart ? 'Proceed to checkout' : 'Add to cart' }}</button>
        <div v-if="in_cart" class="caption text-center mt-sm">
            <i class="icon-check text-green"></i> Item has been added to the cart
        </div>
        <div class="d-flex gap-md align-items justify-center caption mt-sm" v-else>
            <div class="d-flex gap-sm align-items">
                <img :src="`${ images_url }/lightning.webp`" class="d-inline-block" style="height:15px" loading="lazy">
                Digital download
            </div>
            <div class="d-flex gap-sm align-items">
                <img :src="`${ images_url }/flag.webp`" class="d-inline-block" style="height:15px" loading="lazy">
                Designed in United States
            </div>
            <div class="d-flex gap-sm align-items">
                <img :src="`${ images_url }/stars.webp`" class="d-inline-block" style="height:15px" loading="lazy">
                Lifetime access
            </div>
        </div>
    </div>
</template>

<script>

import { defineComponent } from 'vue'

const KEY = 'cart'; // Ключ для localStorage

export default defineComponent({
    name: "single",
    data() {
        return {
            stats: window.stats || [],

            isAdded: false, // добавлен ли товар в корзину
            isLoading: false, // защита от множественных запросов
            product_id: 0,
            quantity: 1,

            _sale_grant: 0,
            sale_grant: false,
            _sale_price: false,
            sale_price: false,
            price: false,
            discount: false,

            images: false,
            sku_key: 'default', // выбранная вариация по умолчанию или текущая
            grant: window.grant || false, // есть ли грант
            ball: parseInt( window.ball || 0 ), // сколько на балансе
            sku: window.SKU || false, // выбранная вариация по умолчанию или текущая
            sku_group: window.SKU_GROUP || false, // группы атрибутов для внешнего вида
            sku_items: window.SKU_ITEMS || false, // аттрибуты по группам
            sku_attr: window.SKU_ATTR || false, // сами вариации ключ => атрибуты

            cart_items: [],
            NumberFormat: {},
        }
    },
    computed: {
        domain() {
            return window.location.hostname.replace('www', '')
        },
        images_url() {
            return 'https://' + this.domain + '/templates/Goya/assets/images';
        },
        // Выбранный товар + вариация в корзине
        in_cart() {
            // Проверяем, что оба ID определены и не пустые
            if( ! this.product_id || ! this.sku.id ) {
                return false;
            }

            // Ищем в массиве элемент, где product_id и variation_id совпадают с нашими значениями
            const added = this.cart_items.some(item => {
                return item.product_id === this.product_id &&
                    item.variation_id === this.sku.id;
            });

            if( added ) {
                this.isAdded = true;
                setTimeout(() => {
                    this.isAdded = false;
                }, 3000)
            }

            return added;
        },
    },
    mounted() {

        this.NumberFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: this.stats.currency || 'USD'});

        const product = document.querySelector('input[name="product_id"]')
        if( product ) {
            this.product_id = parseInt( product.value )
        }

        if( ! this.sku_group ) {
            this.setVariation('default')
        } else if( this.sku_attr ) {

            const n = Object.keys( this.sku_attr ).length
            if( n > 1 ) {

                if( this.sku_attr.hasOwnProperty('default') )
                    delete this.sku_attr.default;
                this.sku_key = Object.keys( this.sku_attr )[0]
                this.setVariation( this.sku_key )
            } else {
                this.sku_key = Object.keys( this.sku_attr )[0]
                this.setVariation( this.sku_key )
            }
        }

        // инициализируем хранилище
        this.getStorageCarts();

        // слушаем событие успешного добавления в корзину
        document.addEventListener('updatedCart', this.handleUpdatedCart);
    },
    beforeUnmount() {
        document.removeEventListener('updatedCart', this.handleUpdatedCart);
    },
    methods: {

        capitalizeFirstLetter(val) {
            val = val.trim();
            return String(val).charAt(0).toUpperCase() + String(val).slice(1);
        },

        indKey( array, elem, targetValue ) {
            return array.findIndex( item => item[ elem ] === targetValue );
        },

        checkActive( item, group_id ) {
            return this.sku_key.includes(`${group_id}:${item.property_id}`) ? 'active' : ''
        },

        /**
         * Присваивает основную вариацию для покупки
         */
        setVariation( key ) {

            // проверяем наличие вариации
            if( !! this?.sku_attr[ key ] ) {

                this.sku = this.sku_attr[ key ]

                // назначаем текущие цены
                if( this.grant && this.ball > 0 ) {
                    const d = this.sku._sale_price - this.ball

                    this._sale_grant = parseInt( d < 0 ? this.sku._sale_price : this.ball )
                    this._sale_price = Math.round( d < 0 ? 0 : d )
                } else {
                    this._sale_price = this.sku._sale_price
                    this._sale_grant = 0
                }

                this.sale_price = this.NumberFormat.format( this._sale_price / 100 );
                this.sale_grant = this.NumberFormat.format( this._sale_grant / 100 );
                this.price = this.sku.price

                if( this.sku._sale_price < this.sku._price ) {
                    this.discount = Math.round( (
                        (this.sku._price - this.sku._sale_price) / this.sku._price
                    ) * 100 ) + '%';
                } else {
                    this.discount = false;
                }

            } else {
                this._sale_price = false;
                this.sale_price = false;
                this.price = false;
                this.discount = false;
            }
        },

        /**
         * После успешного обновления корзины, лезем в хранилище и проверяем есть ли вариация+товар в корзине у клиента
         */
        handleUpdatedCart(e) {
            console.log(e);
            if( !e.detail?.storage || e.detail.storage !== KEY)
                return;

            this.getStorageCarts()

            setTimeout(() => {
                this.isLoading = false;
            }, 1500)
        },

        getStorageCarts() {
            const stored = localStorage.getItem( KEY );
            if( stored ) {
                const data = JSON.parse(stored);
                this.cart_items = data.items || [];
            }
        },

        /**
         * Добавляем текущую вариацию в корзину
         */
        async addToCart() {

            if( this.isLoading )
                return;

            if( this.in_cart ) { // если товар в корзине и ещё раз жмут на кнопку, то переходим на чекаут
                window.location.href = window.location.origin + '/checkout';
                return;
            }

            this.isLoading = true;

            setTimeout(() => { // на всякий случай выключаем
                this.isLoading = false;
            }, 5000)

            const e = new CustomEvent('addToCart', {
                detail: {
                    product_id: this.product_id,
                    variation_id: this.sku.id || 0,
                    quantity: this.quantity
                },
                bubbles: true, // событие может распространяться по дереву DOM
                cancelable: true // можно отменить событие preventDefault()
            })
            document.dispatchEvent( e );
        }
    }
})
</script>

<style scoped>

</style>